import config from "./config";
import { statusHandeling } from "./statusHandeling";
function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    if (user.key) {
      return { Authorization: "Token  " + user.key };
    } else {
      return {};
    }
  } else {
    return {};
  }
}

const EditHealthCategory = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  data["office_id"] = localStorage.getItem("selectedOffice");
  const raw = JSON.stringify(data);

  const req = new Request(config.apiGateway.URL + "/clinics/health-category/" + data.id + "/?office_id=" + localStorage.getItem("selectedOffice"), {
    body: raw,
    method: "PUT",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const createNewMainProcedure = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  //data["office"] = localStorage.getItem("selectedOffice")
  const raw = JSON.stringify(data);

  const req = new Request(config.apiGateway.URL + "/clinics/procedure-lc/?office_id=" + localStorage.getItem("selectedOffice"), {
    body: raw,
    method: "post",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const EditProcedureImpact = async (data, id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  data["office"] = localStorage.getItem("selectedOffice");
  data["health_category"] = data["health_category"] + "";
  const raw = JSON.stringify(data);

  const req = new Request(config.apiGateway.URL + "/clinics/procedure-impact-rud/" + id + "/?office_id=" + localStorage.getItem("selectedOffice"), {
    body: raw,
    method: "PATCH",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const CreateNewProcedure = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  data["office"] = localStorage.getItem("selectedOffice");
  const raw = JSON.stringify(data);

  const req = new Request(config.apiGateway.URL + "/clinics/procedure-impact/", {
    body: raw,
    method: "post",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const CreateNewHealthCategory = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  data["office"] = localStorage.getItem("selectedOffice");
  const raw = JSON.stringify(data);

  const req = new Request(config.apiGateway.URL + "/clinics/health-category/", {
    body: raw,
    method: "post",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const cancelPayment = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/billpay/cancel-payment-request/?id=" + id, {
    method: "post",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

// Connect the office's Helcim account (the tokens its patient payments go
// through). Logged in, office admins only, tokens in the body — this replaced the
// payment package's open /payment/check-business-onboarding/<office>/<js>/<account>/
// URL, which anyone could visit to rewrite an office's tokens.
const connectHelcimAccount = async (officeId, jsToken, accountToken) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(config.apiGateway.URL + "/billpay/offices/" + officeId + "/helcim-account/", {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({ js_token: jsToken, account_token: accountToken }),
  });
  const response = await fetch(req);
  let json = {};
  try {
    json = await response.json();
  } catch (e) {
    json = {};
  }
  return { ...json, status: response.status };
};

const getProviderDetail = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/provider-detail/" + id + "/", {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getProviderList = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL + "/clinics/list-office-providers/?page=" + 1 + "&office_id=" + localStorage.getItem("selectedOffice"),
    {
      method: "GET",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getSubcriptionDetail = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/membership_plans/membership-detail/" + id + "/", {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getCardData = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/total-ar-amounts/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getMaxAmountAR = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/max-ar-amount/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getReasonsList = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/billpay/payment-reason-list/", {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getIntervalsForPayment = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/billpay/pr-available-intervals/?id=" + id, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getIntervalsForPaymentByHash = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/billpay/email-pr-available-intervals/?id=" + id, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getAvailableIntervals = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/billpay/payment-interval-list/", {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const searchGuarantor = async (search) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL + "/clinics/guarantor-lc/?page=0&search=" + search + "&office_id=" + localStorage.getItem("selectedOffice"),
    {
      method: "GET",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getGuarantor = async (search) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  let queryParams = "";
  if (search) queryParams += `&search=${search}`;

  const req = new Request(config.apiGateway.URL + `/clinics/guarantor-lc/?page=0${queryParams}&office_id=` + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getGuarantor2 = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL + "/clinics/patient-guarantors-list/?office_id=" + localStorage.getItem("selectedOffice") + "&patient_id=" + id,
    {
      method: "GET",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getPatient = async (search) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL + "/clinics/patient-list/?page=0&office_id=" + localStorage.getItem("selectedOffice") + "&search=" + search,
    {
      method: "GET",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getPatient2 = async (search) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/patient-list/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getStripeKey = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" });

  const req = new Request(config.apiGateway.URL + "/clinics/get-stripe-public_key/", {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getARDetail = async (data, page = 1) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  // After redirecting to the ar-details page, the data isn't just a number but someting like `#/requestpayment/&ARid=536` (for some reasons 🙃)
  // This will cause CORS error and break the application is it doesn't handled.
  if (data.includes("paymentrequest")) data = data.split("&ARid=")[1];

  const req = new Request(config.apiGateway.URL + "/clinics/ar-detail/" + data + "/?page=" + page, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const updateGetAR = async (provider, guarantor, practice_id, min_date, max_date, entry_id, min_amount, max_amount, patient_id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  var url = "/clinics/ar-list/?office_id=" + localStorage.getItem("selectedOffice");
  if (entry_id && entry_id.length > 0) url += "&entry_id=" + entry_id;

  if (provider && provider > -1) url += "&provider_id=" + provider;

  if (guarantor && guarantor > -1) url += "&guarantor=" + guarantor;

  if (practice_id && practice_id > -1) url += "&practice_id=" + practice_id;

  if (min_date && min_date.length > 0) url += "&min_date=" + min_date;

  if (max_date && max_date.length > 0) url += "&max_date=" + max_date;

  if (min_amount && min_amount > 0) url += "&min_amount=" + min_amount;

  if (max_amount && max_amount > -1) url += "&max_amount=" + max_amount;

  if (patient_id) url += "&patient_id=" + patient_id;

  const req = new Request(config.apiGateway.URL + url, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const updateGetAR2 = async (guarantor, practice_id, min_date, max_date, entry_id, min_amount, max_amount, dueDate, page) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  var url = "/clinics/ar-list/?office_id=" + localStorage.getItem("selectedOffice");
  if (guarantor && guarantor > -1) url += "&guarantor=" + guarantor;

  if (practice_id && practice_id > -1) url += "&practice_id=" + practice_id;

  if (min_date && min_date.length > 0) url += "&min_date=" + min_date;

  if (max_date && max_date.length > 0) url += "&max_date=" + max_date;

  if (min_amount && min_amount > 0) url += "&min_amount=" + min_amount;

  if (max_amount && max_amount > -1) url += "&max_amount=" + max_amount;
  url += "&amounts_between=" + dueDate;

  url += "&page=" + page;

  const req = new Request(config.apiGateway.URL + url, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const getAR = async (page) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/ar-list/?page=" + page + "&office_id=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const office_services = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/booking/get-appointment-type/?office=" + data + "&page=0", {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  return json;
};

const officeprofile = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  // Guard: this endpoint takes the office PRIMARY KEY (a positive integer). Any
  // non-numeric value — missing (null), the string "null"/"undefined", or a
  // Sikka office_id like "D16096" left by a stale/other code path — would hit
  // get-office-profile/<bad>/ → 404, and statusHandeling turns ANY 404 into an
  // app-wide redirect to #/error404 (every page breaks). Skip instead.
  const selectedOffice = localStorage.getItem("selectedOffice");
  const selectedOfficePk = Number(selectedOffice);
  if (!selectedOffice || !Number.isFinite(selectedOfficePk) || selectedOfficePk <= 0) {
    return { status: 0 };
  }

  const req = new Request(config.apiGateway.URL + "/clinics/get-office-profile/" + selectedOffice + "/", {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  statusHandeling.statusCodeHandeling(response.status);
  const json = await response.json();
  json.status = response.status;
  localStorage.setItem("officeLogo", JSON.stringify(json));
  return json;
};

const get_patient_search = async (data, search) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/patient/?office=" + data + "&search=" + search, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  if (response.status !== 204) {
    const json = await response.json();

    return json;
  } else {
    return { data: {} };
  }
};

const get_guarantor_search = async (data, search) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/guarantor-lc/?page=0&office_id=" + data + "&search=" + search, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  if (response.status !== 204) {
    const json = await response.json();

    return json;
  } else {
    return { data: {} };
  }
};

const get_patient = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/patient/?office=" + data, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  if (response.status !== 204) {
    const json = await response.json();

    return json;
  } else {
    return { data: {} };
  }
};

const get_payment_requests = async (page_size, page, search_term, office, repay, guarantor_id = undefined) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  let filterQuery = "";
  if (guarantor_id) filterQuery += `&guarantor_id=${guarantor_id}`;
  if (search_term) filterQuery += `&search=${search_term}`;

  const req = new Request(
    config.apiGateway.URL + `/billpay/paymentrequests/?page=${page}&page_size=${page_size}&office_id=${office}&has_repay=${repay}${filterQuery}`,
    {
      method: "GET",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

const get_payment_requests2 = async (page_size, page, search_term, office, repay, id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL +
      `/billpay/paymentrequests/?page=${page}&page_size=${page_size}&search=${search_term}&office_id=${office}&has_repay=${repay}&guarantor_id=${id}`,
    {
      method: "GET",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

const declineAppointment = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const raw = JSON.stringify({
    approved: false,
  });
  const req = new Request(config.apiGateway.URL + "/booking/approve-appointment/" + id + "/", {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

const getUserOffices = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/practice-users/", {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const createUser = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const raw = JSON.stringify({
    email: data.email,
    username: data.username,
    phone_number: data.phone_number,
  });
  const req = new Request(config.apiGateway.URL + "/clinics/create-user/", {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

const setOfficeAdmin = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const raw = JSON.stringify({
    username: data.username,
    office: data.office_id,
  });
  const req = new Request(config.apiGateway.URL + "/clinics/set-office-access/", {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

const approveAppointment = async (time, id, approve) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const raw = JSON.stringify({
    approved: approve,
    appointment_datetime: time,
  });
  const req = new Request(config.apiGateway.URL + "/booking/approve-appointment/" + id + "/", {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

const createGuarantor = async (first_name, last_name, email, phone_number, city, birth_date, address, patient_state, Zipcode) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const raw = JSON.stringify({
    first_name: first_name,
    last_name: last_name,
    email: email,
    phone: phone_number,
    city: city,
    birth_date: birth_date,
    address: address,
    zip_code: Zipcode,
    state: patient_state,
    office: localStorage.getItem("selectedOffice"),
  });
  const req = new Request(config.apiGateway.URL + "/clinics/create-patient/?office_id=" + localStorage.getItem("selectedOffice"), {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

const createGuarantor2 = async (id, first_name, last_name, email, phone_number, address, state, zipcode) => {
  const myHeaders = {
    "Content-Type": "application/json",
    ...authHeader(),
  };

  const raw = JSON.stringify({
    firstname: first_name,
    lastname: last_name,
    email: email,
    cell: phone_number,
    address_line1: address,
    state: state,
    zipcode: zipcode,
  });

  const req = new Request(
    `${config.apiGateway.URL}/clinics/create-guarantor-for-patient/?office_id=${localStorage.getItem("selectedOffice")}&patient_id=${id}`,
    {
      body: raw,
      method: "POST",
      headers: myHeaders,
    },
  );

  try {
    const response = await fetch(req);
    const json = await response.json();
    statusHandeling.statusCodeHandeling(response.status);
    json.status = response.status;
    return json;
  } catch (error) {
    console.error("Error creating guarantor:", error);
    throw error;
  }
};

const createPatient = async (first_name, last_name, email, phone_number, city, birth_date, address) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const raw = JSON.stringify({
    first_name: first_name,
    last_name: last_name,
    email: email,
    phone: phone_number,
    city: city,
    birth_date: birth_date,
    address: address,
    office: localStorage.getItem("selectedOffice"),
  });
  const req = new Request(config.apiGateway.URL + "/clinics/patient/", {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

const createPayReqAR = async (formData) => {
  const myHeaders = Object.assign(authHeader());

  const req = new Request(config.apiGateway.URL + "/billpay/paymentrequest/", {
    body: formData,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

const createPayReq = async (formData) => {
  const myHeaders = Object.assign(authHeader());

  const req = new Request(config.apiGateway.URL + "/billpay/paymentrequest/", {
    body: formData,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

const resetConfirm = async (password1, password2, uid, token) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" });
  const raw = JSON.stringify({
    new_password1: password1,
    new_password2: password2,
    uid: uid,
    token: token,
  });
  const req = new Request(config.apiGateway.URL + "/password/reset/confirm/", {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json = await response.json();
  json.status = response.status;
  return json;
};
const passwordReset = async (email) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" });
  const raw = JSON.stringify({
    email: email,
  });
  const req = new Request(config.apiGateway.URL + "/password/reset/", {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

const upload_pdf_file = async (formData) => {
  const myHeaders = Object.assign(authHeader());
  const req = new Request(config.apiGateway.URL + "/clinics/file/", {
    body: formData,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

const add_provider = async (data) => {
  const myHeaders = Object.assign(authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/create-provider/", {
    body: data,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  // Use _httpStatus so Provider model field errors (e.g. status) are not overwritten.
  json._httpStatus = response.status;
  return json;
};

const getBadge = async (page) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url = config.apiGateway.URL + "/billpay/new-objects-count/?office_id=" + localStorage.getItem("selectedOffice");
  const req = new Request(url, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json1 = await response.json();
  var json = {};
  json.data = json1;
  json.status = response.status;
  return json;
};

const unApprovedAppointment = async (page) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url = config.apiGateway.URL + "/booking/unapproved-appointments-list/?office_id=" + localStorage.getItem("selectedOffice") + "&page=" + page;
  const req = new Request(url, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json1 = await response.json();
  var json = {};
  json.data = json1;
  json.status = response.status;
  return json;
};

const get_provider = async (office, appointment_type, extra = {}) => {
  const myHeaders = Object.assign(authHeader());
  const params = new URLSearchParams();
  params.set("office", office);
  if (appointment_type) {
    params.set("appointment_type", appointment_type);
  }
  if (extra && typeof extra.search === "string" && extra.search.trim()) {
    params.set("search", extra.search.trim());
  }
  if (extra && typeof extra.ordering === "string" && extra.ordering.trim()) {
    params.set("ordering", extra.ordering.trim());
  }
  const url = config.apiGateway.URL + "/clinics/get-provider/?" + params.toString();
  const req = new Request(url, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json1 = await response.json();
  var json = {};
  json.data = json1;
  json.status = response.status;
  statusHandeling.statusCodeHandeling(response.status);

  return json;
};

const add_provider_times = async (weekday, start, end, provider) => {
  const myHeaders = Object.assign(authHeader(), {
    "Content-Type": "application/json",
  });
  var url = "";

  url = config.apiGateway.URL + "/clinics/providerschedules/";

  const raw = JSON.stringify({
    weekday,
    start,
    end,
    provider,
  });

  const req = new Request(url, {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json1 = await response.json();
  var json = {};
  json.data = json1;
  json.status = response.status;

  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const getLogo = async () => {
  const myHeaders = Object.assign(authHeader());
  var url = "";

  url = config.apiGateway.URL + "/clinics/get-smilin-logo/";

  const req = new Request(url, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json1 = await response.json();
  var json = {};
  json.data = json1;
  json.status = response.status;
  json.status = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  localStorage.setItem("smilepassLogo", JSON.stringify(json));
  return json;
};

const get_provider_times = async (id) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";

  url = config.apiGateway.URL + "/clinics/providerschedules/?provider=" + id;

  const req = new Request(url, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json1 = await response.json();
  var json = {};
  json.data = json1;
  json.status = response.status;
  json.status = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const getPracticeOffices = async () => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url = config.apiGateway.URL + "/clinics/get-practice-offices/";

  const req = new Request(url, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json1 = await response.json();
  var json = {};
  json.data = json1;
  json.status = response.status;
  json.status = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const EditService = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const raw = JSON.stringify(data);

  const req = new Request(config.apiGateway.URL + "/membership_plans/services-update-delete/" + data.id + "/", {
    body: raw,
    method: "PUT",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  statusHandeling.statusCodeHandeling(res.status);
  return res;
};

const removeProcedure = async (id) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url = config.apiGateway.URL + "/clinics/procedure-impact/" + id + "/?office_id=" + localStorage.getItem("selectedOffice");

  const req = new Request(url, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  } else {
    const res = {
      json: { message: "succssfull" },
      status: 204,
      message: "Service deleted successfully",
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }
};

const DeleteHealthCategory = async (id) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url = config.apiGateway.URL + "/clinics/health-category/" + id + "/?office_id=" + localStorage.getItem("selectedOffice");

  const req = new Request(url, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  } else {
    const res = {
      json: { message: "succssfull" },
      status: 204,
      message: "Service deleted successfully",
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }
};

const DeletePlan = async (id) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url = config.apiGateway.URL + "/membership_plans/membership-plan-delete/" + id + "/";

  const req = new Request(url, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  } else {
    const res = {
      json: { message: "succssfull" },
      status: 204,
      message: "Service deleted successfully",
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }
};

const deleteService = async (id) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url = config.apiGateway.URL + "/membership_plans/services-update-delete/" + id + "/";

  const req = new Request(url, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  } else {
    const res = {
      json: { message: "succssfull" },
      status: 204,
      message: "Service deleted successfully",
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }
};

const getServiceList = async (page) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url = config.apiGateway.URL + "/membership_plans/services-list-create/?page=" + page + "&office_id=" + localStorage.getItem("selectedOffice");

  const req = new Request(url, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json1 = await response.json();
  var json = {};
  json.data = json1;
  json.status = response.status;

  return json;
};

const CreateServiceList = async (Sservice) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const raw = JSON.stringify(Sservice);

  const req = new Request(
    config.apiGateway.URL + "/membership_plans/services-list-create/" + "?office_id=" + localStorage.getItem("selectedOffice"),
    {
      body: raw,
      method: "POST",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };
  return res;
};

const GetTransactionSearch = async (value, state, page) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url =
    config.apiGateway.URL +
    "/billpay/transaction-state-list/?search=" +
    value +
    "&state=" +
    state +
    "&page=" +
    page +
    "&office_id=" +
    localStorage.getItem("selectedOffice");

  const req = new Request(url, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json1 = await response.json();
  var json = {};
  json.data = json1;
  json.status = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const GetTransaction = async (state, page) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url =
    config.apiGateway.URL +
    "/billpay/transaction-state-list/?state=" +
    state +
    "&page=" +
    page +
    "&office_id=" +
    localStorage.getItem("selectedOffice");

  const req = new Request(url, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json1 = await response.json();
  var json = {};
  json.data = json1;
  json.status = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};


// --- Platform requests (suggestions reviewed in the CRM) --------------------
// Submitting is open to any signed-in user: the FTC staff who dial a carrier are
// the ones who discover the number is stale. The server validates the payload
// against an allow-list, so this can never reach a field outside the modal.
const submitPlatformRequest = async (body) => {
  const headers = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const response = await fetch(
    new Request(config.apiGateway.URL + "/crm/requests/submit/", {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    }),
  );
  let json = null;
  try { json = await response.json(); } catch (e) { json = null; }
  return { json, status: response.status };
};

// Super-admin only (server-enforced).
const listPlatformRequests = async (status = "pending") => {
  const headers = Object.assign(authHeader());
  const url = config.apiGateway.URL + "/crm/requests/?status=" + encodeURIComponent(status);
  const response = await fetch(new Request(url, { method: "GET", headers }));
  let json = [];
  try { json = await response.json(); } catch (e) { json = []; }
  return { json, status: response.status };
};

const reviewPlatformRequest = async (id, action, note = "") => {
  const headers = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const url = config.apiGateway.URL + "/crm/requests/" + id + "/" + action + "/";
  const response = await fetch(
    new Request(url, { method: "POST", headers, body: JSON.stringify({ note }) }),
  );
  let json = null;
  try { json = await response.json(); } catch (e) { json = null; }
  return { json, status: response.status };
};

const getAdministeredOffices = async () => {
  const myHeaders = Object.assign(authHeader());
  const req = new Request(config.apiGateway.URL + "/clinics/administered-offices/", {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  let json1 = [];
  try {
    json1 = await response.json();
  } catch (e) {
    json1 = [];
  }
  return { data: json1, status: response.status };
};

// The office's per-feature switches + banking state (/clinics/office-features/).
// Deliberately NOT routed through statusHandeling: that redirects the whole app on
// a 404/500, and a missing/older endpoint here must just mean "today's defaults".
const getOfficeFeatureStatus = async (officeId) => {
  const req = new Request(
    config.apiGateway.URL + "/clinics/office-features/?office_id=" + encodeURIComponent(officeId),
    { method: "GET", headers: Object.assign(authHeader()) },
  );
  const response = await fetch(req);
  let json = null;
  try { json = await response.json(); } catch (e) { json = null; }
  return { json, status: response.status };
};

const checkPracticeAdmin = async () => {
  const myHeaders = Object.assign(authHeader());
  var url = "";

  url = config.apiGateway.URL + "/clinics/check-practice-admin/";

  const req = new Request(url, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);

  var json1 = await response.json();
  var json = {};
  json.data = json1;
  json.status = response.status;
  json.status = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const editProviderActive = async (status, id) => {
  const myHeaders = Object.assign(authHeader(), {
    Accept: "application/json",
    "Content-Type": "application/json",
  });
  var data = JSON.stringify({
    status: status,
  });
  const req = new Request(config.apiGateway.URL + "/clinics/provider-update/" + id + "/?office_id=" + localStorage.getItem("selectedOffice"), {
    body: data,
    method: "PATCH",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  json.status = response.status;

  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const getProviderForUpdate = async (id) => {
  const myHeaders = Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, authHeader());
  const officeId = localStorage.getItem("selectedOffice");
  const req = new Request(config.apiGateway.URL + "/clinics/provider-update/" + id + "/?office_id=" + officeId, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  // Do not set json.status — Provider has a "status" field (Active/Inactive); use _httpStatus for HTTP code.
  json._httpStatus = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const updateProvider = async (id, formData) => {
  const myHeaders = Object.assign(authHeader());
  const officeId = localStorage.getItem("selectedOffice");
  const req = new Request(config.apiGateway.URL + "/clinics/provider-update/" + id + "/?office_id=" + officeId, {
    body: formData,
    method: "PATCH",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  json._httpStatus = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const listInsuranceProviders = async () => {
  const req = new Request(config.apiGateway.URL + "/clinics/insurance-providers/", {
    method: "GET",
    headers: Object.assign({ Accept: "application/json" }, authHeader()),
  });
  const response = await fetch(req);
  const json1 = await response.json();
  const json = {};
  json.data = Array.isArray(json1) ? json1 : json1.results || [];
  json._httpStatus = response.status;
  json.raw = json1;
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

// Module-level cache for the capability matrix. The matrix is hardcoded on
// the backend, so it's static for a session — one fetch per page load is plenty.
let _carrierCapabilitiesPromise = null;

// ───── Per-office insurance-portal credentials ─────
// Backed by /clinics/office/<office_id>/portal-credentials/... endpoints
// (see bookc-backend/clinics/views_portal_credentials.py). Username +
// password are write-only — GET responses NEVER carry secrets, only
// metadata (configured-or-not, last-verified, 2FA session age).

const listPortalCredentials = async (officeId) => {
  const req = new Request(
    config.apiGateway.URL + `/clinics/office/${officeId}/portal-credentials/`,
    {
      method: "GET",
      headers: Object.assign({ Accept: "application/json" }, authHeader()),
    }
  );
  const response = await fetch(req);
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`listPortalCredentials failed (${response.status}): ${text}`);
  }
  return await response.json();
};

// The office's claim-submission identity (Access ID / Unique ID / License #)
// plus its contact block, for the insurance modal. Unlike listPortalCredentials
// this endpoint is readable by FTC personnel, and returns no secrets.
// Returns null rather than throwing: this is decorative, so a failure must never
// break the modal that renders it.
const getOfficeInsuranceIdentity = async (officeId) => {
  if (!officeId) return null;
  try {
    const req = new Request(
      config.apiGateway.URL + `/clinics/office/${officeId}/insurance-identity/`,
      {
        method: "GET",
        headers: Object.assign({ Accept: "application/json" }, authHeader()),
      }
    );
    const response = await fetch(req);
    if (!response.ok) return null;
    return await response.json();
  } catch (err) {
    console.error("getOfficeInsuranceIdentity failed", err);
    return null;
  }
};

// Create/update one account for a portal. Multiple accounts per portal are
// now supported (one per provider); `provider_id` maps the account to a
// provider and `is_default` marks the account used for breakdowns/eligibility.
const savePortalCredentials = async (
  officeId,
  portalCode,
  {
    username,
    password,
    preferred_2fa_destination,
    preferred_2fa_method,
    provider_id,
    is_default,
    // The 6 office-level identity fields, required by the backend only when this
    // save makes the account the portal default. Omitted for non-default saves.
    insurance_profile,
  }
) => {
  const req = new Request(
    config.apiGateway.URL +
      `/clinics/office/${officeId}/portal-credentials/${portalCode}/`,
    {
      method: "POST",
      headers: Object.assign(
        { Accept: "application/json", "Content-Type": "application/json" },
        authHeader()
      ),
      body: JSON.stringify({
        username,
        password,
        preferred_2fa_destination,
        preferred_2fa_method,
        provider_id,
        is_default,
        insurance_profile,
      }),
    }
  );
  const response = await fetch(req);
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`savePortalCredentials failed (${response.status}): ${text}`);
  }
  return await response.json();
};

// Delete/reset are keyed by the credential row id (an office holds several
// accounts per portal now).
const deletePortalCredentials = async (officeId, credentialId) => {
  const req = new Request(
    config.apiGateway.URL +
      `/clinics/office/${officeId}/portal-credentials/${credentialId}/`,
    {
      method: "DELETE",
      headers: Object.assign({ Accept: "application/json" }, authHeader()),
    }
  );
  const response = await fetch(req);
  if (!response.ok && response.status !== 204) {
    const text = await response.text().catch(() => "");
    throw new Error(`deletePortalCredentials failed (${response.status}): ${text}`);
  }
  return true;
};

const resetPortalCredential2FA = async (officeId, credentialId) => {
  const req = new Request(
    config.apiGateway.URL +
      `/clinics/office/${officeId}/portal-credentials/${credentialId}/reset-2fa/`,
    {
      method: "POST",
      headers: Object.assign({ Accept: "application/json" }, authHeader()),
    }
  );
  const response = await fetch(req);
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`resetPortalCredential2FA failed (${response.status}): ${text}`);
  }
  return await response.json();
};

// Make an existing account the per-portal default (breakdowns/eligibility)
// without re-entering its password. `insuranceProfile` (the 6 office-level
// identity fields) is required by the backend unless a complete profile is
// already on file.
const setPortalCredentialDefault = async (officeId, credentialId, insuranceProfile) => {
  const req = new Request(
    config.apiGateway.URL +
      `/clinics/office/${officeId}/portal-credentials/${credentialId}/set-default/`,
    {
      method: "POST",
      headers: Object.assign(
        { Accept: "application/json", "Content-Type": "application/json" },
        authHeader()
      ),
      body: JSON.stringify({ insurance_profile: insuranceProfile || undefined }),
    }
  );
  const response = await fetch(req);
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`setPortalCredentialDefault failed (${response.status}): ${text}`);
  }
  return await response.json();
};

// Manual (non-scraper) carrier login — an admin saves one login per carrier we
// don't scrape (Manulife, Canada Life, ...); FTC staff use it by hand. Keyed by
// InsuranceProvider id.
const saveManualCarrierCredential = async (officeId, providerId, { username, password }) => {
  const req = new Request(
    config.apiGateway.URL +
      `/clinics/office/${officeId}/portal-credentials/carrier/${providerId}/`,
    {
      method: "POST",
      headers: Object.assign(
        { Accept: "application/json", "Content-Type": "application/json" },
        authHeader()
      ),
      body: JSON.stringify({ username, password }),
    }
  );
  const response = await fetch(req);
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`saveManualCarrierCredential failed (${response.status}): ${text}`);
  }
  return await response.json();
};

// Does the office have a stored login FTC can use for this carrier? Metadata
// only ({ exists, credential_id }) — no secrets. Allowed for FTC + admins.
const getCarrierPortalCredential = async (officeId, carrierCode) => {
  const req = new Request(
    config.apiGateway.URL +
      `/clinics/office/${officeId}/portal-credentials/for-carrier/${encodeURIComponent(carrierCode)}/`,
    { method: "GET", headers: Object.assign({ Accept: "application/json" }, authHeader()) }
  );
  const response = await fetch(req);
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`getCarrierPortalCredential failed (${response.status}): ${text}`);
  }
  return await response.json();
};

// Reveal the decrypted { username, password } for a stored login (FTC + admins,
// office-scoped, audited). The caller MUST handle the password transiently —
// copy to clipboard, never render or persist it.
const revealPortalCredential = async (officeId, credentialId) => {
  const req = new Request(
    config.apiGateway.URL +
      `/clinics/office/${officeId}/portal-credentials/${credentialId}/reveal/`,
    { method: "POST", headers: Object.assign({ Accept: "application/json" }, authHeader()) }
  );
  const response = await fetch(req);
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`revealPortalCredential failed (${response.status}): ${text}`);
  }
  return await response.json();
};

const getCarrierCapabilities = async () => {
  if (_carrierCapabilitiesPromise) return _carrierCapabilitiesPromise;
  _carrierCapabilitiesPromise = (async () => {
    try {
      const req = new Request(config.apiGateway.URL + "/clinics/carrier-capabilities/", {
        method: "GET",
        headers: Object.assign({ Accept: "application/json" }, authHeader()),
      });
      const response = await fetch(req);
      if (!response.ok) throw new Error("Failed to load carrier capabilities");
      return await response.json();
    } catch (err) {
      // Reset so a later call can retry after transient failures.
      _carrierCapabilitiesPromise = null;
      throw err;
    }
  })();
  return _carrierCapabilitiesPromise;
};

const getInsuranceProvider = async (id) => {
  const req = new Request(config.apiGateway.URL + "/clinics/insurance-providers/" + id + "/", {
    method: "GET",
    headers: Object.assign({ Accept: "application/json" }, authHeader()),
  });
  const response = await fetch(req);
  let data = {};
  try {
    data = await response.json();
  } catch (e) {
    data = {};
  }
  data._httpStatus = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return data;
};

const createInsuranceProvider = async (body) => {
  const req = new Request(config.apiGateway.URL + "/clinics/insurance-providers/", {
    method: "POST",
    headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, authHeader()),
    body: JSON.stringify(body),
  });
  const response = await fetch(req);
  const json = await response.json();
  json._httpStatus = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const updateInsuranceProvider = async (id, body) => {
  const req = new Request(config.apiGateway.URL + "/clinics/insurance-providers/" + id + "/", {
    method: "PATCH",
    headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, authHeader()),
    body: JSON.stringify(body),
  });
  const response = await fetch(req);
  const json = await response.json();
  json._httpStatus = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const deleteInsuranceProvider = async (id) => {
  const req = new Request(config.apiGateway.URL + "/clinics/insurance-providers/" + id + "/", {
    method: "DELETE",
    headers: Object.assign({ Accept: "application/json" }, authHeader()),
  });
  const response = await fetch(req);
  let json = {};
  try {
    json = await response.json();
  } catch (e) {
    json = {};
  }
  json._httpStatus = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const getOfficeBreakdownProcedureCodes = async (officeId, providerId) => {
  const url =
    config.apiGateway.URL +
    "/clinics/offices/" +
    officeId +
    "/insurance-providers/" +
    providerId +
    "/breakdown-procedure-codes/";
  const req = new Request(url, {
    method: "GET",
    headers: Object.assign({ Accept: "application/json" }, authHeader()),
  });
  const response = await fetch(req);
  let data = {};
  try {
    data = await response.json();
  } catch (e) {
    data = {};
  }
  data._httpStatus = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return data;
};

const setOfficeBreakdownProcedureCodes = async (officeId, providerId, procedureCodes) => {
  const url =
    config.apiGateway.URL +
    "/clinics/offices/" +
    officeId +
    "/insurance-providers/" +
    providerId +
    "/breakdown-procedure-codes/";
  const req = new Request(url, {
    method: "PATCH",
    headers: Object.assign(
      { Accept: "application/json", "Content-Type": "application/json" },
      authHeader()
    ),
    body: JSON.stringify({ procedure_codes: procedureCodes || [] }),
  });
  const response = await fetch(req);
  let dataOut = {};
  try {
    dataOut = await response.json();
  } catch (e) {
    dataOut = {};
  }
  dataOut._httpStatus = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return dataOut;
};

const getOfficeProcedureCategories = async (officeId, providerId) => {
  const url =
    config.apiGateway.URL +
    "/clinics/offices/" +
    officeId +
    "/insurance-providers/" +
    providerId +
    "/procedure-categories/";
  const req = new Request(url, {
    method: "GET",
    headers: Object.assign({ Accept: "application/json" }, authHeader()),
  });
  const response = await fetch(req);
  let data = {};
  try {
    data = await response.json();
  } catch (e) {
    data = {};
  }
  data._httpStatus = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return data;
};

const setOfficeProcedureCategories = async (officeId, providerId, categoryMap) => {
  const url =
    config.apiGateway.URL +
    "/clinics/offices/" +
    officeId +
    "/insurance-providers/" +
    providerId +
    "/procedure-categories/";
  const req = new Request(url, {
    method: "PATCH",
    headers: Object.assign(
      { Accept: "application/json", "Content-Type": "application/json" },
      authHeader()
    ),
    body: JSON.stringify({ category_map: categoryMap || {} }),
  });
  const response = await fetch(req);
  let dataOut = {};
  try {
    dataOut = await response.json();
  } catch (e) {
    dataOut = {};
  }
  dataOut._httpStatus = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return dataOut;
};

const changeOfficeLog = async (data, officeId) => {
  const myHeaders = Object.assign(authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/update-office-profile/" + officeId + "/", {
    body: data,
    method: "PATCH",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  json.status = response.status;

  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const UpdateTransactionState = async (state, id) => {
  const myHeaders = Object.assign(authHeader(), {
    "Content-Type": "application/json",
  });

  const raw = JSON.stringify({
    state: state,
  });
  const req = new Request(config.apiGateway.URL + "/billpay/update-transaction-state/" + id + "/", {
    body: raw,
    method: "PUT",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  json.status = response.status;

  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const Login = async (email, pass) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const raw = JSON.stringify({
    email: email,
    password: pass,
  });

  const req = new Request(config.apiGateway.URL + "/dj-rest-auth/login/", {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  json.status = response.status;
  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const FailedPayments = async (page) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL + "/billpay/list-repay-paymentrequests/?page=" + page + "&office_id=" + localStorage.getItem("selectedOffice"),
    {
      method: "GET",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const GetAllMembership = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL + "/membership_plans/membership-plan-list/" + "?office_id=" + localStorage.getItem("selectedOffice"),
    {
      method: "GET",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();

  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};
const EditOfficeProfile = async (office) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  let value = office;
  delete value.logo;
  const raw = JSON.stringify(value);

  const req = new Request(config.apiGateway.URL + `/clinics/update-office-profile/${office.id}/`, {
    body: raw,
    method: "PATCH",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};
const UpdateReviewFeature = async (item) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const raw = JSON.stringify({ featured: !item.featured });

  const req = new Request(config.apiGateway.URL + `/clinics/update-review/${item.id}/`, {
    body: raw,
    method: "PATCH",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const SetReview = async (token, rate, image, review) => {
  const formData = new FormData();
  formData.append("score", rate);
  formData.append("note", review);
  formData.append("image", image);

  const response = await fetch(config.apiGateway.URL + `/clinics/create-review/${token}/`, {
    method: "POST",
    body: formData,
  });

  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const removeAppointmentType = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/booking/appointment-type-detail/" + id + "/", {
    method: "delete",
    headers: myHeaders,
  });

  const response = await fetch(req);
  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };
    return res;
  } else {
    const res = {
      json: { message: "succssfull" },
      status: 204,
      message: "Appointment type deleted successfully",
    };

    return res;
  }
};

const listOfProviderForCreateAppointment = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/get-provider/?office=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const EditAppointmentType = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + `/booking/appointment-type-detail/` + data.id + "/", {
    body: JSON.stringify(data),
    method: "PATCH",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const createNewAppointmentType = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  data["office"] = localStorage.getItem("selectedOffice");

  const req = new Request(config.apiGateway.URL + `/booking/create-appointment-type/`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getListOfAppointmentTypes = async (page) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL + `/booking/get-appointment-type/?office=` + localStorage.getItem("selectedOffice") + "&page=" + page,
    {
      method: "GET",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getProcedureList = async (page) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL + `/clinics/procedure-list-impact/?page=` + page + "&office_id=" + localStorage.getItem("selectedOffice"),
    {
      method: "GET",
      headers: myHeaders,
    },
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const readPateintListPredetermination = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + `/clinics/list-all-patient-predetermination-files`, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getHealthCategory = async (page) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + `/clinics/health-category/?page=` + page + "&office_id=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const GetProviderDetail = async (token) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + `/clinics/appointment-detail/${token}/`, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const UpdateReviewState = async (item, data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const raw = JSON.stringify({ state: data });

  const req = new Request(config.apiGateway.URL + `/clinics/update-review/${item.id}/`, {
    body: raw,
    method: "PATCH",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};
const getOfficeProfile = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + `/clinics/get-office-profile/${localStorage.getItem("selectedOffice")}/`, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();

  const res = {
    data: json,
    status: response.status,
    message: response.message,
  };

  return res;
};
const getOfficeDetail = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + `/clinics/get-office-detail/${localStorage.getItem("selectedOffice")}/`, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();

  const res = {
    data: json,
    status: response.status,
    message: response.message,
  };

  return res;
};
const GetReview = async (search, pageNumber) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  if (search === "featured") {
    const req = new Request(
      config.apiGateway.URL + `/clinics/reviews/?office_id=${localStorage.getItem("selectedOffice")}&featured=true&page=${pageNumber}`,
      {
        method: "GET",
        headers: myHeaders,
      },
    );
    const response = await fetch(req);
    const json = await response.json();

    const res = {
      data: json,
      status: response.status,
      message: response.message,
    };

    return res;
  } else {
    const req = new Request(
      config.apiGateway.URL + `/clinics/reviews/?office_id=${localStorage.getItem("selectedOffice")}&search=${search}&page=${pageNumber}`,
      {
        method: "GET",
        headers: myHeaders,
      },
    );
    const response = await fetch(req);
    const json = await response.json();

    const res = {
      data: json,
      status: response.status,
      message: response.message,
    };

    return res;
  }
};

const deleteProcedureRUD = async (id) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url = config.apiGateway.URL + "/clinics/procedure-rud/" + id + "/?office_id=" + localStorage.getItem("selectedOffice");

  const req = new Request(url, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  } else {
    const res = {
      json: { message: "succssfull" },
      status: 204,
      message: "Service deleted successfully",
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }
};

const editProcedureRUD = async (data, id) => {
  const myHeaders = Object.assign(authHeader(), {
    Accept: "application/json",
    "Content-Type": "application/json",
  });
  var raw = JSON.stringify(data);
  const req = new Request(config.apiGateway.URL + "/clinics/procedure-rud/" + id + "/?office_id=" + localStorage.getItem("selectedOffice"), {
    body: raw,
    method: "PATCH",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  json.status = response.status;

  statusHandeling.statusCodeHandeling(response.status);
  return json;
};

const getProgressStatus = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + `/billpay/transaction-retreive/` + id + "/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getProgressStatusFaild = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL + `/billpay/payment-request-retreive/` + id + "/?office_id=" + localStorage.getItem("selectedOffice"),
    {
      method: "GET",
      headers: myHeaders,
    },
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const approvePreditermination = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/predetermination-file-change-status", {
    body: JSON.stringify({ id: id }),
    method: "POST",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const approvePostPayment = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + `/clinics/approve-patients-post-payment/?office_id=${localStorage.getItem("selectedOffice")}`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

// Insurance page endpionts
// 1. Gettings insurances
const getInsurances = async (page, status, filters, predeterminationOrPostPayment) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  // const req = new Request(`${config.apiGateway.URL}/predetermination/submissions/?office_id=${localStorage.getItem("selectedOffice")}`, {
  var filter_query = "";

  if (filters.submission_date_from) {
    filter_query += "&upload_date_from=" + filters.submission_date_from;
  }
  if (filters.submission_date_to) {
    filter_query += "&upload_date_to=" + filters.submission_date_to;
  }
  if (filters.patient_ids) {
    filter_query += "&patient_ids=" + filters.patient_ids;
  }
  if (filters.procedure_ids) {
    filter_query += "&procedure_ids=" + filters.procedure_ids;
  }
  if (filters.search) {
    filter_query += "&search=" + filters.search;
  }

  const req = new Request(
    `${config.apiGateway.URL}/clinics/list-predetermination-pdf-files?office=${localStorage.getItem("selectedOffice")}&page=${page}&status=${
      status ? status : ""
    }&type=${predeterminationOrPostPayment}` + filter_query,
    {
      method: "GET",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();

  const res = { json: json, status: response.status, message: response.message };

  return res;
};

const fetchPredeterminationDetails = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/predetermination-details/${id}/?office_id=${localStorage.getItem("selectedOffice")} `, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();

  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// Update (or clear) a patient's shared attention note without touching tags.
// Backs the inline note editor in the breakdown / estimate attention card.
const updatePatientAttentionNote = async (patientId, note) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/patient/${patientId}/attention-note/`, {
    method: "PATCH",
    headers: myHeaders,
    body: JSON.stringify({ manual_attention_note: note || "" }),
  });
  const response = await fetch(req);
  const json = await response.json().catch(() => ({}));
  return { json, status: response.status };
};

// Set a single insurance policy's per-policy OUTCOME + note (the endpoint behind
// the modal's "Mark Verified / Details Needed by Smilepass" control). Only the provided
// fields are sent, so each caller touches exactly what it means to:
//   - note (string) → sets/clears the policy note; pass `undefined` to leave it.
//   - opts.needsAttention (bool) → set/clear the policy's needs-attention flag +
//     the rollup tag.
//   - opts.clearVerified / opts.clearEstimate / opts.clearClaim (bool) → un-mark
//     that success state (button toggle-off, or mutual-exclusivity when marking
//     attention).
// "Mark Verified" itself stays on fulfillVerificationRequest (it fulfills the
// request + meters); this endpoint handles the other transitions.
const updatePolicyAttentionNote = async (policyId, note, opts = {}) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const body = {};
  if (note !== undefined) body.attention_note = note || "";
  if (opts && Object.prototype.hasOwnProperty.call(opts, "needsAttention")) body.needs_attention = !!opts.needsAttention;
  if (opts && opts.clearVerified) body.clear_verified = true;
  if (opts && opts.clearEstimate) body.clear_estimate = true;
  if (opts && opts.clearClaim) body.clear_claim_followup = true;
  // The Details Needed checklist ({ fields: [catalogue keys], other_text }).
  if (opts && opts.ask) body.ask = opts.ask;
  const req = new Request(`${config.apiGateway.URL}/clinics/patients/policy/${policyId}/attention-note/`, {
    method: "PATCH",
    headers: myHeaders,
    body: JSON.stringify(body),
  });
  const response = await fetch(req);
  const json = await response.json().catch(() => ({}));
  return { json, status: response.status };
};

// Per-Case list scoped to a patient (and optionally policy / treatment plan).
// Backs the Insurance Estimates modal's left pane. Returns the
// PredeterminationCase rows with provenance + linked ScrapeJob state.
const listPatientPredeterminationCases = async ({ patientId, policyId, treatmentPlanId } = {}) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const params = new URLSearchParams();
  if (patientId) params.set("patient_id", patientId);
  if (policyId) params.set("policy_id", policyId);
  if (treatmentPlanId) params.set("treatment_plan_id", treatmentPlanId);
  const req = new Request(
    `${config.apiGateway.URL}/clinics/patient-predetermination-cases/?${params.toString()}`,
    { method: "GET", headers: myHeaders },
  );
  const response = await fetch(req);
  const json = await response.json();
  return { json, status: response.status, message: response.message };
};

// Delete one estimate (PredeterminationCase). The backend also reclaims the
// attached PDF and clears "New Estimate Available" when it was the last estimate
// on the policy; auto-generated treatment plans are deliberately kept.
// A 204 has no body, so synthesize one — the repo's DELETE convention.
// Delete one breakdown. The route has always accepted DELETE (it's a
// RetrieveUpdateDestroy view); what it lacked until now was cleanup, so the
// backend also clears the "Breakdown Verified" tag when the last breakdown for a
// policy goes, and re-points the policy's default to the newest survivor.
const deleteInsuranceBreakdown = async (breakdownId) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(
    `${config.apiGateway.URL}/clinics/breakdown-patient-rud/${breakdownId}/`,
    { method: "DELETE", headers: myHeaders },
  );
  const response = await fetch(req);
  if (response.status === 204) return { json: { message: "deleted" }, status: 204 };
  const json = await response.json().catch(() => ({}));
  return { json, status: response.status };
};

const deletePredeterminationCase = async (caseId) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(
    `${config.apiGateway.URL}/clinics/patient-predetermination-cases/${caseId}/`,
    { method: "DELETE", headers: myHeaders },
  );
  const response = await fetch(req);
  if (response.status === 204) return { json: { message: "deleted" }, status: 204 };
  const json = await response.json().catch(() => ({}));
  return { json, status: response.status };
};

/**
 * Edit the note on one estimate (PredeterminationCase).
 *
 * Shares the case route with the delete above, so the same office scoping
 * applies. `notes` is the only field the server will write — everything else in
 * the body is ignored.
 */
const updatePredeterminationCaseNotes = async (caseId, notes) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(
    `${config.apiGateway.URL}/clinics/patient-predetermination-cases/${caseId}/`,
    { method: "PATCH", headers: myHeaders, body: JSON.stringify({ notes: notes || "" }) },
  );
  const response = await fetch(req);
  const json = await response.json().catch(() => ({}));
  return { json, status: response.status };
};

// 2. Uploading insurnace documents
const uploadNewInsurnaces = async (files) => {
  const myHeaders = Object.assign(authHeader());

  const req = new Request(`${config.apiGateway.URL}/clinics/upload-pdf-predetermination-files`, {
    method: "POST",
    headers: myHeaders,
    body: files,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// 3. Getting insurnace predeterminations
const getInsurancePredeterminations = async (insuranceID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(
    `${config.apiGateway.URL} / predetermination / submissions / ${insuranceID} /? office_id = ${localStorage.getItem("selectedOffice")}`,
    {
      method: "GET",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};
const getInsuranceApprovedReceived = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/insurance-status-count/?office_id=${localStorage.getItem("selectedOffice")}`, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

const setTreatmentPatientId = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/bulk-set-treatment-patients/?office_id=${localStorage.getItem("selectedOffice")}`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(data),
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const setTreatmentPredeterminationID = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/bulk-set-treatment-assignment/?office_id=${localStorage.getItem("selectedOffice")}`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(data),
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const setTreatmentProcedureID = async (data, treatmentID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/edit-treatmentprocedure-insurance/${treatmentID}/`, {
    method: "PATCH",
    headers: myHeaders,
    body: JSON.stringify(data),
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

// This is for getting all patients that are extracted by the agent in the insurance breakdwons page.
const getInsurancePatients = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(
    `${config.apiGateway.URL}/clinics/list-insurance-treatment-by-patient/?office_id=${localStorage.getItem("selectedOffice")}`,
    {
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

const getInsuranceBreakdownsPatients = async (page, status, filters) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  let filterQuery = "";

  if (filters.patient_ids) {
    filterQuery += `&patient_ids=${filters.patient_ids}`;
  }
  if (filters.procedure_ids) {
    filterQuery += `&procedure_ids=${filters.procedure_ids}`;
  }
  if (filters.expiry_date) {
    filterQuery += `&expiry_date${filters.expiry_date}`;
  }

  const req = new Request(
    `${config.apiGateway.URL}/clinics/breakdown-patient-list/?office_id=${localStorage.getItem(
      "selectedOffice",
    )}&page=${page}&status=${status}${filterQuery}`,
    {
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// Insurance breakdowns uploading files
const uploadInsuranceBreakdowns = async (formData) => {
  const myHeaders = Object.assign(authHeader());

  formData.append("office_id", localStorage.getItem("selectedOffice"));

  const req = new Request(
    `${config.apiGateway.URL}/clinics/upload-pdf-breakdown-file-no-patient/?office_id=${localStorage.getItem("selectedOffice")}`,
    {
      method: "POST",
      headers: myHeaders,
      body: formData,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

const getInsuranceBreakdownsPatientDetails = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/breakdown-patient-details/?breakdown_id=${Number(id)}`, {
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

const getBreakdownPatientCoverage = async (patientID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/breakdown-patient-coverage-view/?patient_id=${patientID}`, {
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

const updateBreakdownPatientCoverage = async (policyID, data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  // const req = new Request(`${config.apiGateway.URL}/clinics/breakdown-patient-coverage-update/?patient_id=${patientID}`, {
  const req = new Request(`${config.apiGateway.URL}/clinics/breakdown-patient-coverage-update/?policy_id=${policyID}`, {
    headers: myHeaders,
    method: "PUT",
    body: JSON.stringify(data),
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

const setBreakdownSetPatient = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/breakdown-set-patient/?policy_id=${data.policy_id}&breakdown_id=${data.breakdown_id}`, {
    headers: myHeaders,
    method: "POST",
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

const approveBreakdown = async (breakdownID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(
    `${config.apiGateway.URL}/clinics/breakdown-patient-rud/${breakdownID}/?office_id=${localStorage.getItem("selectedOffice")}`,
    {
      headers: myHeaders,
      method: "PATCH",
      body: JSON.stringify({ status: "approved" }),
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

const sendBugReport = async (bugData) => {
  const myHeaders = Object.assign(authHeader());
  const req = new Request(`${config.apiGateway.URL}/data-analytics/bug-reports/`, {
    headers: myHeaders,
    method: "POST",
    body: bugData,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const syncPMSDataModal = async (patientID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/fetch_patients_treatments/?office_id=${localStorage.getItem("selectedOffice")}`, {
    headers: myHeaders,
    method: "POST",
    body: JSON.stringify({ patient_ids: [patientID] }),
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const syncARCards = async (patientID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(
    `${config.apiGateway.URL}/clinics/fetch_patients_accounts_receivables/?office_id=${localStorage.getItem("selectedOffice")}`,
    {
      headers: myHeaders,
      method: "POST",
      body: JSON.stringify({ patient_ids: [patientID] }),
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const getPatientARGuarantors = async (patientID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(
    `${config.apiGateway.URL}/clinics/fetch_guarantors_accounts_receivables/?office_id=${localStorage.getItem("selectedOffice")}`,
    {
      headers: myHeaders,
      method: "POST",
      body: JSON.stringify({ guarantor_ids: [3749] }),
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const getPatientDetails = async (patientId) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/staging-groups/patient-details/${patientId}/`, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const getPatientPolicies = async (patientID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/patients/insurance-policies/?patient_id=${patientID}`, {
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const updatePatientInsurancePolicy = async (policyID, data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/patients/update-insurance-policy/?policy_id=${policyID}`, {
    headers: myHeaders,
    method: "PATCH",
    body: JSON.stringify(data),
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

/** Suggest a policy member's DOB from a matching same-office patient. The office is
 *  derived server-side from policy_id/patient_id (never the client office), and
 *  first/last are the member's name to match. Returns { json:{candidates:[...]}, status }. */
const getMemberDobCandidates = async ({ patientId, policyId, first, last } = {}) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const params = new URLSearchParams();
  if (policyId != null) params.set("policy_id", policyId);
  else if (patientId != null) params.set("patient_id", patientId);
  if (first) params.set("first", first);
  if (last) params.set("last", last);
  const req = new Request(`${config.apiGateway.URL}/clinics/patients/member-dob-candidates/?${params.toString()}`, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  return { json, status: response.status, message: response.message };
};

/** Create or update a policy via patient insurance set (eligibility / patient board). */
const setPatientInsuranceInfo = async (patientID, insuranceInfo) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/patient/insurance/set?patient_id=${patientID}`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(insuranceInfo),
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

/** Step 1: read-only fetch from Sikka. Returns a preview_token + policies the user can confirm/edit. */
const previewPatientPoliciesFromSikka = async (patientID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/patient/insurance/preview-from-sikka/?patient_id=${patientID}`, {
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

/** Step 2: persist what the user confirmed in the Sikka policy review modal. */
const savePatientPoliciesFromSikkaPreview = async (body) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/patient/insurance/save-from-sikka-preview/`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(body),
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

/**
 * Auto-fetch the patient's policies from the PMS and SAVE the confidently
 * matched ones without review. Unknown carriers come back under a preview_token
 * (+ policies) for the review modal to finish. Returns
 * { json: {saved, needs_review, preview_token, policies, no_insurance, warnings}, status }.
 * office is derived server-side from the patient; officeId is threaded only for
 * consistency with the other cross-office insurance reads.
 */
const autoFetchAndSavePolicies = async (patientID, officeId) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const officeQs = officeId != null && officeId !== "" ? `&office_id=${officeId}` : "";
  const req = new Request(
    `${config.apiGateway.URL}/clinics/patient/insurance/auto-fetch-and-save/?patient_id=${patientID}${officeQs}`,
    { method: "POST", headers: myHeaders },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const cancelAutoReminder = async (paymentID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/billpay/payment-requests/${paymentID}/reset-follow-up/`, {
    headers: myHeaders,
    method: "PATCH",
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

export const controller = {
  getOfficeFeatureStatus,
  getBadge,
  getPatient,
  getPatient2,
  getGuarantor2,
  getProgressStatusFaild,
  getProgressStatus,
  declineAppointment,
  approveAppointment,
  unApprovedAppointment,
  getStripeKey,
  getLogo,
  officeprofile,
  office_services,
  get_patient,
  createPatient,
  get_payment_requests,
  upload_pdf_file,
  add_provider,
  passwordReset,
  resetConfirm,
  changeOfficeLog,
  get_provider,
  createPayReq,
  createPayReqAR,
  Login,
  get_provider_times,
  add_provider_times,
  get_patient_search,
  updateGetAR2,
  checkPracticeAdmin,
  getAdministeredOffices,
  submitPlatformRequest,
  listPlatformRequests,
  reviewPlatformRequest,
  getOfficeDetail,
  getPracticeOffices,
  createUser,
  getUserOffices,
  setOfficeAdmin,
  GetReview,
  getOfficeProfile,
  EditOfficeProfile,
  UpdateReviewFeature,
  UpdateReviewState,
  createGuarantor2,
  get_payment_requests2,

  updateGetAR,
  getAR,
  getARDetail,

  createGuarantor,
  getGuarantor,
  searchGuarantor,
  get_guarantor_search,

  GetTransaction,
  UpdateTransactionState,

  getAvailableIntervals,
  getIntervalsForPayment,
  getIntervalsForPaymentByHash,

  getReasonsList,

  getMaxAmountAR,
  getCardData,

  FailedPayments,

  getSubcriptionDetail,

  getServiceList,
  deleteService,
  CreateServiceList,
  EditService,

  GetAllMembership,
  DeletePlan,
  GetTransactionSearch,
  getProviderList,
  cancelPayment,
  authHeader,
  SetReview,
  GetProviderDetail,

  // appointmenttypes
  getListOfAppointmentTypes,
  removeAppointmentType,
  createNewAppointmentType,
  listOfProviderForCreateAppointment,
  EditAppointmentType,

  editProviderActive,
  getProviderForUpdate,
  updateProvider,
  getProviderDetail,

  listInsuranceProviders,
  getInsuranceProvider,
  createInsuranceProvider,
  updateInsuranceProvider,
  deleteInsuranceProvider,
  getOfficeBreakdownProcedureCodes,
  setOfficeBreakdownProcedureCodes,
  getOfficeProcedureCategories,
  setOfficeProcedureCategories,

  getHealthCategory,
  CreateNewHealthCategory,
  DeleteHealthCategory,
  EditHealthCategory,

  getProcedureList,
  CreateNewProcedure,
  removeProcedure,

  connectHelcimAccount,

  createNewMainProcedure,
  deleteProcedureRUD,
  editProcedureRUD,
  EditProcedureImpact,

  // Insurance page endpoints
  getInsurances,
  uploadNewInsurnaces,
  getInsurancePredeterminations,
  fetchPredeterminationDetails,
  listPatientPredeterminationCases,
  deletePredeterminationCase,
  updatePredeterminationCaseNotes,
  deleteInsuranceBreakdown,
  updatePatientAttentionNote,
  updatePolicyAttentionNote,
  approvePreditermination,
  approvePostPayment,
  readPateintListPredetermination,
  getInsuranceApprovedReceived,
  setTreatmentPatientId,
  setTreatmentPredeterminationID,
  setTreatmentProcedureID,

  // Insurance Breakdowns
  getInsurancePatients,
  getInsuranceBreakdownsPatients,
  uploadInsuranceBreakdowns,
  getInsuranceBreakdownsPatientDetails,
  getBreakdownPatientCoverage,
  updateBreakdownPatientCoverage,
  setBreakdownSetPatient,
  approveBreakdown,

  // Bug report
  sendBugReport,

  // Sync PMS Modal Data
  syncPMSDataModal,
  syncARCards,
  getPatientARGuarantors,

  // Patient Policies
  getPatientDetails,
  getPatientPolicies,
  updatePatientInsurancePolicy,
  getMemberDobCandidates,
  setPatientInsuranceInfo,
  previewPatientPoliciesFromSikka,
  savePatientPoliciesFromSikkaPreview,
  autoFetchAndSavePolicies,

  // Cancel auto reminder
  cancelAutoReminder,

  // Carrier capability matrix (hardcoded on backend)
  getCarrierCapabilities,

  // Per-office insurance-portal credentials (SunLife, ProviderConnect)
  listPortalCredentials,
  getOfficeInsuranceIdentity,
  savePortalCredentials,
  deletePortalCredentials,
  resetPortalCredential2FA,
  setPortalCredentialDefault,
  saveManualCarrierCredential,
  getCarrierPortalCredential,
  revealPortalCredential,
};
